import PropTypes from 'prop-types';

import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

import { history } from '../../store';

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.grey[500],
  '&:hover': {
    backgroundColor: theme.palette.grey[600],
  },
}));

const BackButtonComponent = ({ text, backUrl, width }) => {
  const { t } = useTransl();
  return (
    <StyledButton
      type="button"
      variant="contained"
      sx={{ width }}
      disableElevation
      onClick={backUrl ? () => history.push(backUrl) : () => history.goBack()}
    >
      {text || t('actions.back')}
    </StyledButton>
  );
};

BackButtonComponent.propTypes = {
  text: PropTypes.string,
  backUrl: PropTypes.string,
  width: PropTypes.string,
};

export default BackButtonComponent;
